module.exports = __webpack_public_path__ + "static/media/10-no-poets-dont-own-words.18cec5c4.mp3";